import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useLang } from "../hooks/useLanguage";
import { Reveal } from "./Reveal";

const Faq = () => {
  const [open, setOpen] = useState(0);
  const { t } = useLang();

  return (
    <section id="faq" className="bg-ivory text-[#202020] py-24 md:py-32" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 sm:px-10">
        <Reveal>
          <p className="label-caps">{t.UI.faqLabel}</p>
          <h2 className="mt-4 font-serif-lux font-light text-[clamp(2rem,4.5vw,3.4rem)] leading-[1.08] tracking-tight">
            {t.UI.faqTitle}
          </h2>
        </Reveal>
        <div className="mt-12 border-t hairline-light">
          {t.FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="border-b hairline-light">
                <button
                  className="w-full flex items-center justify-between gap-6 py-7 text-start"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-panel-${i}`}
                  data-testid={`faq-question-${i + 1}`}
                >
                  <span className="font-serif-lux text-xl sm:text-2xl font-medium leading-snug">{f.q}</span>
                  <Plus
                    size={20}
                    className={`shrink-0 text-champagne transition-transform duration-500 ${isOpen ? "rotate-45" : ""}`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      id={`faq-panel-${i}`}
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                      data-testid={`faq-answer-${i + 1}`}
                    >
                      <p className="pb-7 pe-10 text-sm sm:text-base text-smoke leading-relaxed max-w-2xl">
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
